<template>
  <div>
    <v-dialog v-model="showDlg" max-width="400" persistent>
      <v-form ref="lForm" @submit.prevent="loginToApp">
        <v-card>
          <v-card-title class="title">Login</v-card-title>
          <v-card-text class="py-0">
            <v-container class="pa-0">
              <v-layout row wrap>
                <v-flex xs12>
                  <vue-tel-input-vuetify
                  ref="refMob"
                  v-model="mobile"
                  label=""
                  placeholder="Enter a mobile number"
                  @keydown.native="ignoreBackspace"
                  @input="keepCursor"
                  :rules="[rules.required]"
                  :input-options="{showDialCode: true}"
                  @validate="validateMob"
                  />
                  <div class="caption grey--text">
                    Enter your mobile number and press send OTP
                  </div>
                  <div class="text-xs-right">
                    <span>
                      <v-layout row wrap>
                        <v-flex xs1 @click="isOTPSent=false" v-if="canResend">
                          <v-checkbox
                          v-model="reqOTPToMobile"
                          class="mt-2"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs8 v-if="secToWait > 0" class="mt-3 text-xs-right">
                          <div class="caption grey--text">Wait {{secToWait}} sec to retry</div>
                        </v-flex>
                        <v-flex xs7 class="mt-3 text-xs-left" v-else-if="canResend || reqOTPToMobile" @click="isOTPSent=false; reqOTPToMobile=!reqOTPToMobile">
                          <div class="caption">Send OTP to mobile as well</div>
                        </v-flex>
                        <v-flex xs8 v-else>
                        </v-flex>
                        <v-flex xs4>
                          <v-btn flat class="mx-0 pa-0 accent--text" @click="sendOTP"
                          :disabled="(!canResend && !isValidNumber) || secToWait > 0"
                          >
                          {{(canResend ? 'Resend' : 'Send') + ' OTP'}}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </span>
                </div>
              </v-flex>
              <v-flex xs12 v-if="isOTPSent">
                <v-alert class="caption pa-2 mt-0" value="true" color="info">
                  <span v-if="reqOTPToMobile">OTP is sent to your mobile & email. Please check and enter here</span>
                  <span v-else>OTP is sent to your email {{OTPRes.contact_email}}. Please check (including spam folder) and enter here</span>
                </v-alert>
              </v-flex>
              <v-flex xs12 v-if="isOTPSent">
                <v-text-field
                v-model.trim="otp" class="pt-0"
                type="number"
                placeholder="Enter OTP"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>

        </v-card-text>
        <v-card-actions class="primary">
          <v-spacer></v-spacer>
          <v-btn flat @click.stop="closeDlg" class="white--text">Cancel</v-btn>
          <v-btn flat type=submit :disabled="beingSaved" class="text-xs-right accent--text">Log in</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>

  <!-- snack bar for error reporting -->
  <v-snackbar :color="sbarCol" v-model="sbar" :timeout="4000" multi-line>
    <span class="mx-auto">{{ sbarMsg }}</span>
  </v-snackbar>

</div>
</template>

<script>
import config from '@/config/app-cfg'
import { login, getUserDevId } from '@/utils/auth'
import handy from '@/utils/handy'
import { VueTelInputVuetify } from 'vue-tel-input-vuetify'

export default {
  components: {
    'vue-tel-input-vuetify': VueTelInputVuetify
  },
  props: ['countrycode'],
  data () {
    return {
      showDlg: true,
      sbar: false,
      sbarMsg: '',
      sbarCol: 'error',
      beingSaved: false,
      userId: '',
      mobile: '',
      otp: '',
      isValidNumber: false,
      isOTPSent: false,
      reqOTPToMobile: false,
      OTPRes: {},
      userExist: false,
      canSendOTP: false,
      rules: handy.rules,
      canResend: false,
      secToWait: 0,
      timer: null,
      countryCode: this.countrycode
    }
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    closeDlg () {
      this.showDlg = false
      this.$emit('closed')
    },
    loginToApp () {
      if (!this.isValidNumber) {
        this.msg('Invalid mobile number')
        return
      }
      if (!this.isOTPSent) {
        this.msg('Click on SEND OTP to receive the OTP')
        return
      }
      // validate current form and move on
      if (this.$refs.lForm.validate() && this.userExist) {
        this.beingSaved = true
        // validate OTP
        let req = {
          contact_phone: this.mobile,
          purpose: 'login',
          otp: this.otp,
          user_device_id: getUserDevId()
        }
        this.axios.post(config.API_URL + '/otp/verify', req)
        .then(response => {
          // log in
          login(this.userId, this.mobile, response.data.api_key)
          // re-route to home page
          this.$router.go('/')
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
          return
        })
      } else {
        if (this.mobile && !this.userExist) {
          this.msg('User not exist with this mobile number. ' +
          'Please join your community before trying to login')
        }
      }
    },
    sendOTP () {
      // validate existance of user
      this.mobile = this.mobile.replace(/ /g, '')
      var qry = {
        params: {
          contact_phone: this.mobile
        }
      }
      this.axios.get(config.API_URL + '/getUserByPhone/', qry)
      .then(response => {
        if (response.data.length === 0) {
          this.userExist = false
          this.msg('User not exist with this mobile number. ' +
          'Please join your community before trying to login')
          return
        } else {
          this.userId = response.data[0].user_id
          this.countryCode = response.data[0].country_code || this.countryCode
          this.userExist = true
          this.canSendOTP = false
          // send otp
          this.axios.post(config.API_URL + '/otp/send', {contact_phone: this.mobile, purpose: 'login', country_code: this.countryCode, req_otp_to_mobile: this.reqOTPToMobile})
          .then(response => {
            // this.msg('An OTP is sent to your mobile & e-mail. Please check and enter here', 2)
            this.OTPRes = response.data
            // mask email
            let maskedEmail = this.OTPRes.contact_email.split('')
            for (let i = 3; i < this.OTPRes.contact_email.indexOf('@'); i += 2) {
              maskedEmail[i] = '*'
            }
            this.OTPRes.contact_email = maskedEmail.join('')
            this.isOTPSent = true
            // enable resend after few sec
            this.canResend = false
            this.secToWait = 30
            if (this.timer) {
              clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
              this.secToWait--
              if (!this.secToWait) {
                clearInterval(this.timer)
                this.canResend = true
              }
            }, 1000)
          })
          .catch(err => {
            this.msg(err.response.data)
          })
        }
      })
    },
    ignoreBackspace (e) {
      if (e.key === 'Backspace') {
        const start = this.mobile.length - 1
        this.mobile = this.mobile.substring(0, start)
        e.preventDefault()
      }
    },
    keepCursor () {
      this.$refs.refMob.cursorPosition = this.mobile.length
    },
    validateMob ({ number, valid, country }) {
      this.isValidNumber = valid
      if (valid) {
        this.mobile = number.e164
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?017a51d5